/**
 * Immutable implementation of a Map. Call `map.freeze()` to lock write access to the map.
 */
export class ImmutableMap<K, V> extends Map<K, V> {
  private isFrozen = false

  // Overwrite and permit clearing of all CountryConfigs
  public clear() {
    if (this.isFrozen) {
      throw new Error('Not allowed to clear')
    }
  }

  public set(key: K, value: V) {
    if (this.isFrozen) {
      throw new Error('Not allowed to set value')
    }
    return super.set(key, value)
  }

  // Overwrite and permit deleting a CountryConfig
  public delete(key: K) {
    if (this.isFrozen) {
      throw new Error('Not allowed to clear')
    }

    return super.delete(key)
  }

  public freeze() {
    this.isFrozen = true
  }
}
